module.exports = __webpack_public_path__ + "img/256.289ad9dd.png";